import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import { Form, useActionData, useNavigation } from "react-router-dom";
import { Container } from "@mui/material";
import { useForm } from 'react-hook-form';
import { ToastContainer } from "react-toastify";
import { Check, DoneAll } from "@mui/icons-material";

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';



export default function Register() {
    const navigation = useNavigation();
    const inputDisabled = navigation.state === "submitting";
    const error = useActionData() as string | undefined;

    const { handleSubmit, register: formRegister, formState: { isSubmitting, errors } } = useForm();

    return (
        <Container maxWidth="xl" sx={{ display: 'flex', justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
            <CssBaseline />

            <Grid container spacing={0} justifyContent="center" alignItems="center" sx={{ minHeight: "100vh" }}>
                {/* Image */}
                <Grid item xs={12} md={6}>
                    <Paper
                        sx={{
                            backgroundImage: "url(https://www.janonce.com/img/megaphone.png)",
                            backgroundRepeat: "no-repeat",
                            backgroundColor: (t) =>
                                t.palette.mode === "light"
                                    ? t.palette.grey[50]
                                    : t.palette.grey[900],
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            minHeight: "100%",
                            display: { xs: 'none', md: 'block' },
                            opacity: 0.9,
                        }}
                    >
                        <Typography sx={{ color: "#00008B", padding: 4, fontSize: { xs: 30, md: 40 }, textAlign: "center", fontWeight: "bold" }} component="header">
                            Plus de 20 000 clients nous font confiance.
                        </Typography>

                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: { xs: "center", md: "flex-start" }, justifyContent: "flex-start", textAlign: { xs: "center", md: "left" }, opacity: 1, paddingX: { xs: 2, md: 12 } }}>
                            {[
                                "Améliorer votre réputation",
                                "Éliminer les bounces",
                                "Sans frais cachés",
                                "Sans engagement",
                                "Simple & Rapide",
                                "Confidentialité des données"
                            ].map((text, index) => (
                                <Typography key={index} sx={{ padding: 2, fontFamily: "Roboto", fontSize: 18, fontWeight: 800, color: "black" }} variant="h6" component="h2">
                                    <DoneAll sx={{ color: "#00008B", marginRight: 2 }} /> {text}
                                </Typography>
                            ))}
                        </Box>
                    </Paper>
                </Grid>

                {/* Formulaire d'inscription */}
                <Grid item xs={12} md={6}>
                    <Paper elevation={6} square sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%", padding: { xs: 3, sm: 5, md: 10 } }}>
                        <Box component={Form} method="post" sx={{ mt: 2, width: "100%", justifyContent: "center", alignItems: "center" }}>
                            <Typography component="h1" variant="h5" sx={{ fontFamily: "Roboto" }}>
                                Sign up for free
                            </Typography>

                            <Typography component="h3" variant="body2" sx={{ mb: 2, fontSize: 16, textAlign: "start", padding: 1 }}>
                                Already have an account? <a href="/login" style={{ fontSize: 16, padding: 2, fontWeight: 500 }}>Sign In</a>
                            </Typography>

                            <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 2, mt: 1 }}>
                                {/* Champ Username */}
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="username"
                                    label="Username"
                                    name="username"
                                    autoComplete="username"
                                    disabled={inputDisabled}
                                />

                                {/* Champ Firstname */}
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="first_name"
                                    label="Firstname"
                                    name="first_name"
                                    autoComplete="first_name"
                                    disabled={inputDisabled}
                                />
                            </Box>

                            {/* Champ Email */}
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="email"
                                label="Email Address"
                                name="email"
                                type="email"
                                autoComplete="email"
                                autoFocus
                                disabled={inputDisabled}
                            />

                            {/* Champ Password */}
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label="Password"
                                type="password"
                                id="password"
                                autoComplete="current-password"
                                disabled={inputDisabled}
                            />

                            {/* Message toast */}
                            <ToastContainer />

                            {/* Sign Up Button */}
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2, backgroundColor: "#00008B", ":hover":{backgroundColor:"#002f8b", fontWeight:600} }}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? <CircularProgress size={24} /> : "Sign Up"}
                            </Button>
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </Container>
    );
}

